// extracted by mini-css-extract-plugin
module.exports = {"logo":"index_logo_3J59V","menu":"index_menu_hhtUd","isScrolling":"index_isScrolling_2zGQv","resizeHandle":"index_resizeHandle_3EIo9","isResizing":"index_isResizing_46YLh"};